import TRANSLATE_DE from "./de/translations.json";
import TRANSLATE_EN from "./en/translations.json";

export const translations = {
  de: { translation: TRANSLATE_DE },
  en: { translation: TRANSLATE_EN },
};
